import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { MemberCardPool } from "../../../service/api-response/MemberCardPoolsSuccessResponse";

export const GET_MEMBER_CARD_POOLS = "MEMBER-CARD-TYPE:GET_MEMBER_CARD_POOLS";
export const GET_MEMBER_CARD_POOLS_FAIL =
  "MEMBER-CARD-TYPE:GET_MEMBER_CARD_POOLS_FAIL";
export const GET_MEMBER_CARD_POOLS_SUCCESS =
  "MEMBER-CARD-TYPE:GET_MEMBER_CARD_POOLS_SUCCESS";

export interface GetMemberCardPoolsAction extends Action {
  type: typeof GET_MEMBER_CARD_POOLS;
  organization: OrganizationKeyName;
}

export interface GetMemberCardPoolsFailAction extends Action {
  type: typeof GET_MEMBER_CARD_POOLS_FAIL;
  organization: OrganizationKeyName;
}

export interface GetMemberCardPoolsSuccessAction extends Action {
  type: typeof GET_MEMBER_CARD_POOLS_SUCCESS;
  organization: OrganizationKeyName;
  memberCardPools: MemberCardPool[];
}

export const getMemberCardPoolsAction = (
  organization: OrganizationKeyName
): GetMemberCardPoolsAction => ({
  type: GET_MEMBER_CARD_POOLS,
  organization,
});

export const getMemberCardPoolsFailAction = (
  organization: OrganizationKeyName
): GetMemberCardPoolsFailAction => ({
  type: GET_MEMBER_CARD_POOLS_FAIL,
  organization,
});

export const getMemberCardPoolsSuccessAction = (
  organization: OrganizationKeyName,
  memberCardPools: MemberCardPool[]
): GetMemberCardPoolsSuccessAction => ({
  type: GET_MEMBER_CARD_POOLS_SUCCESS,
  organization,
  memberCardPools,
});
